import { Tooltip } from 'antd';
import React from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

const FacebookSignInButton = ({ signup, facebookLogin }) => {
  const responseFacebook = (response) => {
    facebookLogin(response);
  };
  const responseFacebookFail = (response) => {
    facebookLogin(null, true);
  };
  return (
    <FacebookLogin
      appId={window.$FACEBOOK_CLIENT_ID}
      fields="name,email,picture"
      callback={responseFacebook}
      onFailure={responseFacebookFail}
      render={(renderProps) => (
        <Tooltip title={`${signup ? 'Daftar' : 'Masuk'} dengan Facebook`}>
          <button onClick={renderProps.onClick}>
            <img
              alt=""
              src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"
            />
          </button>
        </Tooltip>
      )}
    />
  );
};

export default FacebookSignInButton;
